export default ({ API }) => ({
  ...API.wrap({
    getMenus({ params = {}, headers = {} } = {}) {
      return this.get('/_exclusive/homepage/menus', 'public', {
        headers,
        params,
      });
    },
    getCategories({ params = {}, headers = {} } = {}) {
      return this.get('/_exclusive/homepage/menus/categories', 'public', {
        headers,
        params,
      });
    },
  }),
});
